var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "600px",
            "custom-class": "cargo-form-dialog",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "cargo-form",
              attrs: { "label-width": "100px", "label-position": "left" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { padding: "0" }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "showCooperateAll" },
                          on: { click: _vm.showCooperateAllHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_ShowCooperateAll"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_CooperateBranchId")
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "branchId",
                              "select-type": _vm.TYPE_NAMES.basic_data_Office,
                              clearable: false,
                              filterable: "",
                              "default-value": Number(_vm.job.branchId),
                              cache: false,
                              "static-options": _vm.officeList,
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.branchId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_CooperateBusinessType")
                                )
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "businessType",
                              "select-type":
                                _vm.TYPE_NAMES.basic_data_CooperationType,
                              multiple: true,
                              clearable: false,
                              filterable: "",
                              "default-multiple-value": _vm.job.businessType,
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.businessType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Operation")))]
                          ),
                          _c("cargo-user-select", {
                            attrs: {
                              no: "opId",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "op"
                              },
                              "default-value": _vm.job.opId || "",
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              change: function(p) {
                                _vm.job.opId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.CustomerService") }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "csrId",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "csr"
                              },
                              "default-value": _vm.job.csrId || "",
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              change: function(p) {
                                _vm.job.csrId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.OverseaCustomerService")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "overseaOp",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "overseaOp"
                              },
                              "default-value": _vm.job.overseaOp || "",
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              change: function(p) {
                                _vm.job.overseaOp = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Documents") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "planner",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "doc"
                              },
                              "default-value": _vm.job.dcId || "",
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              change: function(p) {
                                _vm.job.dcId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.isSeaExport
                        ? _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("SeaExport.BookingAgent") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "bookingAgent",
                                  "select-type":
                                    _vm.TYPE_NAMES.basic_data_Company,
                                  filterable: "",
                                  "method-params": {
                                    bookingAgent: true,
                                    companyLob: "seaExport",
                                    active: true
                                  },
                                  "default-value": _vm.seaJob.bookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.bookingAgentChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _vm.isSeaExport
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.ShippingCompanyContractNo"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { no: "scNo" },
                                model: {
                                  value: _vm.seaJob.scNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.seaJob, "scNo", $$v)
                                  },
                                  expression: "seaJob.scNo"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AirlinePerson2") }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "planner",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "seaLine"
                              },
                              "default-value": _vm.job.planner || "",
                              placeholder: " ",
                              disabled: !_vm.editable
                            },
                            on: {
                              change: function(p) {
                                _vm.job.planner = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Sales") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "sales",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.job.sales || "",
                              disabled: true,
                              placeholder: " "
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "cargoSalesId",
                              "method-params": {
                                category: "role",
                                shape: "salesOfGoods"
                              },
                              "default-value": _vm.job.cargoSalesId || "",
                              disabled: true,
                              placeholder: " "
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRole1",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "userDefinedRole1"
                              },
                              "default-value": _vm.job.userDefinedRoleId1 || "",
                              disabled: true,
                              placeholder: " "
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                          }
                        },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRole2",
                              "method-params": {
                                officeId: _vm.job.branchId,
                                category: "role",
                                shape: "userDefinedRole2"
                              },
                              "default-value": _vm.job.userDefinedRoleId2 || "",
                              disabled: true,
                              placeholder: " "
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Remarks") } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", no: "remark", rows: 4 },
                            model: {
                              value: _vm.remark,
                              callback: function($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "confirm" },
                  on: { click: _vm.handleSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "cancel" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.cooperationBranchListDialog.visible
        ? _c("cooperation-branch-list", {
            attrs: {
              visible: _vm.cooperationBranchListDialog.visible,
              "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
              job: _vm.cooperationBranchListDialog.job,
              "order-center-branch":
                _vm.cooperationBranchListDialog.orderCenterBranch,
              "show-cooperate-all":
                _vm.cooperationBranchListDialog.showCooperateAll
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cooperationBranchListDialog,
                  "visible",
                  $event
                )
              },
              cancel: function() {
                return (_vm.cooperationBranchListDialog.visible = false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }